<template>
  <div class="flex items-center">
    <!-- Mobile: toggle on click -->
    <button
      v-if="isMobile"
      ref="iconEl"
      :class="class"
      class="flex items-center cursor-pointer border-0 bg-transparent p-0"
      v-tooltip.focus.bottom="{
        value: text,
        position: positionMobile,
        pt: { text: 'font-just' },
      }"
      @click="toggleTooltip"
      type="button"
      v-html="computedIcon"
    ></button>

    <!-- Desktop: hover tooltip -->
    <div
      v-else
      class="flex items-center cursor-pointer"
      :class="class"
      v-tooltip.bottom="{
        value: text,
        position: positionDesktop,
        pt: { text: 'font-just' },
      }"
      v-html="computedIcon"
    ></div>
  </div>
</template>

<script setup>
import { infoSvg } from "@/utils/commonSvg";
import { ref, onMounted, onBeforeUnmount, nextTick, computed } from "vue";

const props = defineProps({
  text: { type: String, required: true },
  icon: { type: String, default: "" },
  useInfoSvg: { type: Boolean, default: true },
  positionDesktop: { type: String, default: "bottom" },
  positionMobile: { type: String, default: "top" },
  class: { type: String, default: "" },
});

const iconEl = ref(null);
const tooltipVisible = ref(false);
const isMobile = ref(false);

const computedIcon = computed(() => {
  if (props.icon) return props.icon;
  return props.useInfoSvg ? infoSvg({ width: "24", height: "24" }) : "";
});

function checkIsMobile() {
  isMobile.value =
    window.innerWidth < 768 ||
    "ontouchstart" in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
}

function toggleTooltip() {
  if (!iconEl.value) return;

  if (tooltipVisible.value) {
    iconEl.value.blur();
    tooltipVisible.value = false;
  } else {
    nextTick(() => {
      iconEl.value.focus();
      tooltipVisible.value = true;
    });
  }
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener("resize", checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkIsMobile);
});
</script>